/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './record-history.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from 'ngx-bootstrap/dropdown/bs-dropdown.state';
import * as i4 from 'ngx-bootstrap/dropdown/bs-dropdown.directive';
import * as i5 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as i6 from 'ngx-bootstrap/dropdown/bs-dropdown.config';
import * as i7 from 'ngx-bootstrap/dropdown/bs-dropdown-toggle.directive';
import * as i8 from 'ngx-bootstrap/dropdown/bs-dropdown-menu.directive';
import * as i9 from '../../../../../app/shared/components/record-history/record-history.component';
import * as i10 from '../../../../../app/core/services/common-api.service';
import * as i11 from '../../../../../app/core/services/global-app-state.service';
const styles_RecordHistoryComponent:any[] = [i0.styles];
export const RenderType_RecordHistoryComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_RecordHistoryComponent,data:{}});
function View_RecordHistoryComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'li',[['role',
      'menuitem']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n            '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),2,'a',[['class','dropdown-item'],['href','javascript:void(0)']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onRevisionClick(_v.context.$implicit)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(3,(null as any),['On ',' by ',
          ''])),i1.ɵppd(4,2),(_l()(),i1.ɵted(-1,(null as any),['\n          ']))],
      (null as any),(_ck,_v) => {
        const currVal_0:any = i1.ɵunv(_v,3,0,_ck(_v,4,0,i1.ɵnov((<any>(<any>(<any>(<any>(<any>_v.parent).parent).parent).parent).parent),
            0),_v.context.$implicit.updated,'medium'));
        const currVal_1:any = _v.context.$implicit.user_email;
        _ck(_v,3,0,currVal_0,currVal_1);
      });
}
function View_RecordHistoryComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n          '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_RecordHistoryComponent_5)),
      i1.ɵdid(3,802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n        ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.revisions;
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
function View_RecordHistoryComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'ul',[['class',
      'dropdown-menu'],['role','menu']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_RecordHistoryComponent_4)),
      i1.ɵdid(3,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf'],ngIfElse:[1,'ngIfElse']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (_co.revisions.length > 0);
    const currVal_1:any = i1.ɵnov((<any>(<any>(<any>_v.parent).parent).parent),6);
    _ck(_v,3,0,currVal_0,currVal_1);
  },(null as any));
}
function View_RecordHistoryComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),14,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,16777216,(null as any),
          (null as any),11,'div',[['class','btn-group'],['dropdown','']],[[2,'dropup',
              (null as any)],[2,'open',(null as any)],[2,'show',(null as any)]],(null as any),
          (null as any),(null as any),(null as any))),i1.ɵprd(512,(null as any),i3.BsDropdownState,
          i3.BsDropdownState,([] as any[])),i1.ɵdid(4,212992,(null as any),0,i4.BsDropdownDirective,
          [i1.ElementRef,i1.Renderer2,i1.ViewContainerRef,i5.ComponentLoaderFactory,
              i6.BsDropdownConfig,i3.BsDropdownState],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n\n      '])),(_l()(),i1.ɵeld(6,0,(null as any),
          (null as any),3,'span',[['class','navbar-text pull-right dropdown-toggle'],
              ['dropdownToggle','']],[[1,'aria-haspopup',0],[1,'disabled',0],[1,'aria-expanded',
              0]],[[(null as any),'click'],['document','click'],[(null as any),'keyup.esc']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,7).onClick($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('document:click' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,7).onDocumentClick($event)) !== false);
              ad = (pd_1 && ad);
            }
            if (('keyup.esc' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,7).onEsc()) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(7,147456,(null as any),0,i7.BsDropdownToggleDirective,
          [i3.BsDropdownState,i1.ElementRef],(null as any),(null as any)),(_l()(),
          i1.ɵted(8,(null as any),['Last edit on ',' by ',''])),i1.ɵppd(9,2),(_l()(),
          i1.ɵted(-1,(null as any),['\n\n      '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_RecordHistoryComponent_3)),i1.ɵdid(12,
          16384,(null as any),0,i8.BsDropdownMenuDirective,[i3.BsDropdownState,i1.ViewContainerRef,
              i1.TemplateRef],(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n  ']))],(_ck,_v) => {
    _ck(_v,4,0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵnov(_v,4).dropup;
    const currVal_1:any = i1.ɵnov(_v,4).isOpen;
    const currVal_2:any = (i1.ɵnov(_v,4).isOpen && i1.ɵnov(_v,4).isBs4);
    _ck(_v,2,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = true;
    const currVal_4:any = i1.ɵnov(_v,7).isDisabled;
    const currVal_5:any = i1.ɵnov(_v,7).isOpen;
    _ck(_v,6,0,currVal_3,currVal_4,currVal_5);
    const currVal_6:any = i1.ɵunv(_v,8,0,_ck(_v,9,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        0),_co.revisions[0].updated,'medium'));
    const currVal_7:any = _co.revisions[0].user_email;
    _ck(_v,8,0,currVal_6,currVal_7);
  });
}
function View_RecordHistoryComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'history-container']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_RecordHistoryComponent_2)),
      i1.ɵdid(3,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf'],ngIfElse:[1,'ngIfElse']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:boolean = !_co.selectedRevision;
    const currVal_1:any = i1.ɵnov((<any>_v.parent),4);
    _ck(_v,3,0,currVal_0,currVal_1);
  },(null as any));
}
function View_RecordHistoryComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'button',[['class',
      'btn btn-revert']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.onRevertClick()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['Revert to']))],
      (null as any),(null as any));
}
function View_RecordHistoryComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['or ']))],(null as any),(null as any));
}
function View_RecordHistoryComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_RecordHistoryComponent_7)),
      i1.ɵdid(2,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵeld(4,0,(null as any),(null as any),2,'span',[['class','selected-revision']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(5,(null as any),['',' by ',''])),i1.ɵppd(6,2),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵeld(8,0,(null as any),(null as any),
          4,'span',[['class','btn-current']],(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onCurrentRevisionClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_RecordHistoryComponent_8)),
      i1.ɵdid(11,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['go back to current\n  '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.enableRevert;
    _ck(_v,2,0,currVal_0);
    const currVal_3:any = _co.enableRevert;
    _ck(_v,11,0,currVal_3);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>_v.parent),0),_co.selectedRevision.updated,
        'medium'));
    const currVal_2:any = _co.selectedRevision.user_email;
    _ck(_v,5,0,currVal_1,currVal_2);
  });
}
function View_RecordHistoryComponent_9(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(1,
      0,(null as any),(null as any),1,'span',[['class','navbar-text pull-right']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['No revision to display'])),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(null as any),(null as any));
}
export function View_RecordHistoryComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[i1.ɵpid(0,i2.DatePipe,[i1.LOCALE_ID]),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_RecordHistoryComponent_1)),
      i1.ɵdid(2,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n'])),
      (_l()(),i1.ɵand(0,[['revisionSelectedTemplate',2]],(null as any),0,(null as any),
          View_RecordHistoryComponent_6)),(_l()(),i1.ɵted(-1,(null as any),['\n\n'])),
      (_l()(),i1.ɵand(0,[['hasNoRevisionTemplate',2]],(null as any),0,(null as any),
          View_RecordHistoryComponent_9))],(_ck,_v) => {
    var _co:i9.RecordHistoryComponent = _v.component;
    const currVal_0:any = _co.revisions;
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
export function View_RecordHistoryComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-record-history',
      ([] as any[]),(null as any),(null as any),(null as any),View_RecordHistoryComponent_0,
      RenderType_RecordHistoryComponent)),i1.ɵdid(1,245760,(null as any),0,i9.RecordHistoryComponent,
      [i10.CommonApiService,i1.ChangeDetectorRef,i11.GlobalAppStateService],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const RecordHistoryComponentNgFactory:i1.ComponentFactory<i9.RecordHistoryComponent> = i1.ɵccf('re-record-history',
    i9.RecordHistoryComponent,View_RecordHistoryComponent_Host_0,{enableRevert:'enableRevert'},
    {revisionChange:'revisionChange',revisionRevert:'revisionRevert'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/shared/components/record-history/record-history.component.ngfactory.ts